import { useMutation } from "@tanstack/react-query";
import { updateProjectDetails } from "../api/update-project-details";
export const useUpdateProjectDetailsMutate = (projectId, queryParams) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (updateProjectDetailsRequest) => {
            return updateProjectDetails(projectId, queryParams, updateProjectDetailsRequest);
        },
        retry: false
    });
};
